import { DropdownMenu } from "@radix-ui/react-dropdown-menu";

import {
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";
import FilterButton from "common/components/ui/FilterButton";
import { LEADS_FACETS } from "common/constants";

import type { JSX } from "react";
import type { AudienceFilters } from "../../../../../types";

interface AudienceFilterDesktopProps {
  facetKey: keyof Omit<AudienceFilters, "keyword">;
  isMiningTargets: boolean;
  filters: AudienceFilters;
  contentComponent: JSX.Element;
}

export default function AudienceFilterDesktop({
  facetKey,
  isMiningTargets,
  filters,
  contentComponent,
}: AudienceFilterDesktopProps) {
  const selection = filters[facetKey];
  const { icon: Icon, label } = LEADS_FACETS[facetKey];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={isMiningTargets}>
        <FilterButton
          leftIcon={<Icon weight="fill" />}
          size="sm"
          rightIcon={
            Array.isArray(selection) &&
            !!selection.length && (
              <span className="flex size-4 text-button-xs shrink-0 items-center justify-center rounded-full bg-black-950 text-xs-bold text-white">
                {selection.length}
              </span>
            )
          }
        >
          {label}
        </FilterButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {contentComponent}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
